export const SET_REPEAT = "SET_REPEAT";
export const SET_WAIT = "SET_WAIT";
